<template>
    <div class="px-3 px-md-2 pt-3 pt-md-0 pb-1">

        <div v-if="loading" class="text-center py-2"><i class="fas fa-spinner fa-spin"></i></div>

        <p v-else-if="clicks.length == 0" class="pt-3 text-center">No clicks</p>

        <div v-else>

          <!-- Desktop -->
          <table class="table datatables-basic d-none d-md-table">
          <tbody>
            <tr v-for="(click, index) in clicks" :key="index.id">
              
              <td class="pl-3">
                <a :href="'http://ip-api.com/json/'+click.ip" target="_blank" class="iplink">{{click.ip}}</a>
              </td>
              <td class="agent"><span :title="click.agent"><i :class="`${getAgentLogo(click.agent)} fa-2x logo`"></i></span></td>
              <td class="pl-3">{{click.city}}</td>
              <td class="pr-4">
                <img :src="'/images/flags/svg/'+getFlag(click.country)" class="country_flag" :title="click.country">
              </td>
              <td class="text-nowrap"><timeago
                  :datetime="click.created_at"
                  :auto-update="60"
                  :title="formatDateMoment(click.created_at)"></timeago></td>
            </tr>
          </tbody>
        </table>

        <!-- Mobile -->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">IP • Country • Date</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(click, index) in clicks" :key="index">
  
        <td class="pl-2">
            <div>{{ click.ip }}</div>
            <div>{{ click.country }}</div>
            <div><timeago
                  :datetime="click.created_at"
                  :auto-update="60"
                  :title="formatDateMoment(click.created_at)"></timeago></div>
        </td>

            </tr>
          </tbody>
        </table>

        </div>


  </div>
</template> 

<script>

export default {
    props : ['advert_id'],
  data() {
    return {
      clicks: [],
      tabIndex: 0,
      loading: false,
    };
  },

  created() {
    this.getClicks();

    // Echo.private("clicks")
    //   .listen("NewClick", (event) => {
    //     this.getClicks();
    //   });
  },

  methods: {
    getClicks() {
      
      this.loading = true;

      axios.post('/adverts/clicks', {advert_id: this.advert_id}).
      then((response) => {
        this.clicks = response.data;
        this.loading = false;
      });
    },

  },
};
</script>

<style scoped>
a.iplink { font-weight:normal !important; }
.logo { position: relative; top: 0px;}
td.agent { text-align: center; width:70px; }
td.source { text-align: center; width:60px; }
</style>